export class DefaultError extends Error {
  constructor() {
    super("Oops something went wrong, please try again.");
  }
}
